// O que trava o fechamento do caixa (dono, 22/10/2026): pedidos e mesas em
// aberto na loja inteira, como o servidor devolve em GET /api/caixa/em-aberto e
// no 409 de POST /api/caixa/{id}/fechar (`detail: {codigo, mensagem, pedidos, mesas}`).
import { statusConfig } from "../../pedidos/lib/pedidoConstants";
import { dataBR, hora, tempoAberto } from "./caixa";

export const CODIGO_EM_ABERTO = "em_aberto";

const MODULOS = {
  cardapio: "Cardápio", balcao: "Balcão", totem: "Totem", mesas: "Mesas", mesaqr: "Mesa QR", comandas: "Comandas",
  delivery: "Delivery", ifood: "iFood", whatsapp: "WhatsApp",
};
// Status que a tela de Pedidos não rotula (pedidoConstants) mas que travam o caixa
const STATUS_EXTRA = { agendado: "Agendado", aceito: "Aceito", na_bag: "Na bag" };

export const rotuloModulo = (modulo) => MODULOS[String(modulo || "").toLowerCase()] || modulo || "—";
export const rotuloStatus = (status) => statusConfig[status]?.label || STATUS_EXTRA[status] || status || "—";

// dataBR dá "05/10/2026"; na lista basta dia/mês
const diaMes = (iso) => dataBR(iso).slice(0, 5);

/** "há 2h10" até dois dias; depois "desde 05/10". */
export function desdeQuando(iso, agora = new Date()) {
  if (!iso) return "";
  const horas = (agora - new Date(iso)) / 3600000;
  return horas >= 48 ? `desde ${diaMes(iso)}` : `há ${tempoAberto(iso, agora)}`;
}

/** Agendado mostra para quando é; os outros, há quanto tempo estão abertos. */
export function quandoDoPedido(p, agora = new Date()) {
  if (p?.agendado_para) {
    const d = new Date(p.agendado_para);
    if (!Number.isNaN(d.getTime())) {
      const hoje = d.toDateString() === agora.toDateString();
      return `agendado para ${hoje ? "hoje" : diaMes(p.agendado_para)} ${hora(p.agendado_para)}`;
    }
  }
  return desdeQuando(p?.criado_em, agora);
}

export const temEmAberto = (e) => Boolean(e?.pedidos?.length || e?.mesas?.length);

/** "2 pedidos e 1 mesa em aberto" */
export function resumoEmAberto(e) {
  const nP = e?.pedidos?.length || 0;
  const nM = e?.mesas?.length || 0;
  const partes = [];
  if (nP) partes.push(`${nP} pedido${nP > 1 ? "s" : ""}`);
  if (nM) partes.push(`${nM} mesa${nM > 1 ? "s" : ""}`);
  return partes.length ? `${partes.join(" e ")} em aberto` : "";
}

// "Ir até ele" leva à tela do módulo do pedido (dono, 25/10/2026): mesa → Mesas,
// balcão → Balcão, delivery → Delivery... Totem vai para o Balcão (a aba Totem
// abre o modo autoatendimento) e os pedidos online vão para o Delivery, onde
// aparecem. Módulo desconhecido continua abrindo o pedido em Vendas → Pedidos.
const TELA_DO_MODULO = {
  mesas: { rota: "/mesas", nome: "Mesas" }, mesaqr: { rota: "/mesas", nome: "Mesas" },
  comandas: { rota: "/comandas", nome: "Comandas" },
  balcao: { rota: "/balcao", nome: "Balcão" }, totem: { rota: "/balcao", nome: "Balcão" },
  delivery: { rota: "/delivery", nome: "Delivery" }, cardapio: { rota: "/delivery", nome: "Delivery" },
  whatsapp: { rota: "/delivery", nome: "Delivery" }, ifood: { rota: "/delivery", nome: "Delivery" },
};

/** {rota, nome} da tela onde o pedido é resolvido. */
export function telaDoPedido(p) {
  return TELA_DO_MODULO[String(p?.modulo || "").toLowerCase()]
    || { rota: `/vendas/pedidos?openPedido=${encodeURIComponent(p?.pedido_id)}`, nome: "o pedido" };
}
export const destinoDoPedido = (p) => telaDoPedido(p).rota;
// Mesa em aberto leva só à tela de Mesas, sem abrir a mesa (dono, 25/10/2026)
export const destinoDaMesa = () => "/mesas";

/** Lista estruturada que vem no 409 do fechar (caixaApi guarda em `erro.detalhe`), ou null. */
export function emAbertoDoErro(erro) {
  const d = erro?.detalhe;
  if (!d || d.codigo !== CODIGO_EM_ABERTO) return null;
  return { pedidos: d.pedidos || [], mesas: d.mesas || [] };
}
